import React from 'react';
import styled from '@emotion/styled';
import type { ItemDetail } from 'src/types/itemInventory';
interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  item: ItemDetail;
}
const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: scale-down;
`;
const ItemThumbnail: React.FC<Props> = ({
  item
}) => {
  return <Image src={item.thumbnailImageUrl} alt={item.displayName} data-sentry-element="Image" data-sentry-component="ItemThumbnail" data-sentry-source-file="index.tsx" />;
};
export default ItemThumbnail;